module.exports = __webpack_public_path__ + "static/media/sort-shapes-up.f1c171ab.svg";